<template>
  <el-dialog
    v-el-drag-dialog
    :append-to-body="appendToBody"
    :visible.sync="innerVisible"
    :title="$t('SystemMaintenance.BranchSelection')"
    width="800px"
    :close-on-click-modal="false"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :row-data="rowData"
      :check-sub-record="checkSubRecord"
      :deselect-sub-record="checkSubRecord"
      :check-main-record="checkMainRecord"
      :deselect-main-record="checkMainRecord"
      style="height:400px"
    />
    <template slot="footer">
      <div style="text-align: left">
        <line-label :label="$t('SystemMaintenance.CurrentlySelectedProject') + selectRowsLabel" style="color: blue;" />
      </div>
      <div style="display: flex;justify-content: space-between;margin-top: 5px;">
        <el-checkbox v-model="checkSubRecord">{{ $t('SystemMaintenance.CheckParentCompanyWithSubsidiary') }}</el-checkbox>
        <div>
          <el-button no="confirm" type="primary" @click="onConfirm">{{ $t('common.confirm') }}</el-button>
          <el-button no="reset" @click="onReset">{{ $t('common.reset') }}</el-button>
          <el-button no="cancel" @click="innerVisible = false">{{ $t('common.cancel') }}</el-button>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import lodash from 'lodash'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getCacheListByKey } from '@/utils/basicDataCache'
import { ensureExecuteSuccess } from '@/utils/commonUtil'
import { cache, cacheName } from '@/utils/cacheManager'
export default {
  name: 'BranchSelectDialog',
  props: {
    visible: { type: Boolean, required: true },
    value: { type: Array, required: true },
    officeList: { type: Array, default: null },
    appendToBody: { type: Boolean, default: false }
  },
  data() {
    return {
      innerVisible: this.visible,
      gridOptions: {
        rowSelection: 'multiple',
        groupDefaultExpanded: 1,
        suppressCellSelection: true,
        suppressRowClickSelection: true,
        treeData: true,
        getDataPath: (data) => {
          return data.path.split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('CargoMsg.Cargo_Name'),
          field: 'code',
          width: 759,
          suppressMenu: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            innerRenderer: params => {
              return this.getSelectLabel(params.data)
            },
            checkbox: (params) => {
              return true
            }
          },
          tooltip: (params) => {
            return ''
          }
        },
        columnDefs: [],
        onRowSelected: (event) => {
          const rows = event.api.getSelectedRows()
          this.handleSelectRowsLabel(rows)
        },
        context: {
          componentParent: this
        }
      },
      rowData: [],
      selectRowsLabel: '',
      checkSubRecord: true,
      checkMainRecord: true
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.innerVisible) {
      this.init()
    }
  },
  methods: {
    async init() {
      let currentOfficeList = []
      if (this.officeList) {
        currentOfficeList = lodash.cloneDeep(this.officeList)
      } else {
        currentOfficeList = lodash.cloneDeep(getCacheListByKey(TYPE_NAMES.basic_data_Office_All))
      }
      if (currentOfficeList && currentOfficeList.length > 0) {
        currentOfficeList.sort((a, b) => {
          const aTime = new Date(a.dateCreated).getTime()
          const bTime = new Date(b.dateCreated).getTime()
          return aTime - bTime
        })
      }
      await cache.load(cacheName.CONFIG)
      if (cache.config.get('ToExoSystem') === 'TP') {
        this.checkMainRecord = false
        this.checkSubRecord = false
        this.setGridPath(currentOfficeList, null)
      } else {
        const rowMap = new Map()
        if (currentOfficeList && currentOfficeList.length > 0) {
          for (const row of currentOfficeList) {
            rowMap.set(row.uuid, row)
            if (!row.parentBranchUuid || !rowMap.has(row.parentBranchUuid)) {
              row.path = row.uuid
            } else {
              const parentRow = rowMap.get(row.parentBranchUuid)
              row.path = parentRow.path + ',' + row.uuid
            }
          }
        }
      }
      // currentOfficeList处理以后再赋值给列表，否则会有警告
      this.rowData = currentOfficeList || []
      await ensureExecuteSuccess(() => this.gridOptions.api)
      const nodes = this.gridOptions.api.rowModel.rootNode.allLeafChildren
      const expandedKeys = []
      if (this.value && this.value.length > 0) {
        for (const node of nodes) {
          if (this.value.includes(node.data.officeId)) {
            node.setSelected(true)
            expandedKeys.push(...node.data.path.split(','))
          } else {
            node.setSelected(false)
          }
        }
      } else {
        this.gridOptions.api.deselectAll()
      }
      this.gridOptions.api.clearFocusedCell()
      /* 默认展开第一项和选中项 */
      for (const item of nodes) {
        if (expandedKeys.includes(item.data.uuid)) {
          item.expanded = true
        } else {
          item.expanded = false
        }
      }
      const expandedNode = nodes[0]
      if (expandedNode) {
        expandedNode.expanded = true
      }
      this.gridOptions.api.onGroupExpandedOrCollapsed()
    },
    getSelectLabel(data) {
      const name = this.$selectByLang(data.chineseName, data.englishName || data.chineseName)
      if (data.code) {
        return `[${data.code}]` + name
      } else {
        return name
      }
    },
    handleSelectRowsLabel(rows) {
      this.selectRowsLabel = Array.from(rows, p => this.getSelectLabel(p)).join(',')
    },
    onConfirm() {
      const rows = this.gridOptions.api.getSelectedRows()
      const newValue = Array.from(rows, p => p.officeId)
      this.$emit('callback', newValue)
      this.innerVisible = false
    },
    onReset() {
      this.gridOptions.api.deselectAll()
    },
    setGridPath(targetList = [], parentList = null) {
      if (!targetList || targetList.length === 0) {
        return
      }
      // 本次新找到的父节点
      const tempParentList = []
      // 本次未找到父的节点
      const tempTargetList = []
      if (parentList === null) {
        // 第一轮：先把有上级分公司的和没有的区分出来
        for (const item of targetList) {
          if (!item.parentBranchUuid) { // 根节点
            item.path = item.uuid
            tempParentList.push(item)
          } else {
            tempTargetList.push(item)
          }
        }
      } else {
        // 非第一轮：给剩余节点找父节点
        for (const item of targetList) {
          let isFindParent = false
          for (const parentOffice of parentList) {
            if (parentOffice.uuid === item.parentBranchUuid) {
              // 找到父节点，则路径等于父节点的UUID + 当前节点的UUID
              item.path = parentOffice.path + ',' + item.uuid
              tempParentList.push(item)
              isFindParent = true
              break
            }
          }
          if (!isFindParent) {
            tempTargetList.push(item)
          }
        }
      }
      if (tempParentList.length > 0 && tempTargetList.length > 0) {
        this.setGridPath(tempTargetList, tempParentList)
      } else if (tempParentList.length > 0 && tempTargetList.length === 0) {
        console.log('全部处理完毕')
      } else if (parentList != null && tempParentList.length === 0 && tempTargetList.length > 0) {
        for (const item of tempTargetList) {
          item.path = item.uuid
        }
      }
    }
  }
}
</script>
